import { useEffect, useRef } from 'react';

// The CMS is a single-page app: a tab opened before a deploy keeps running the old code until it is reloaded,
// so people kept testing (and saving data with) a version we had already fixed. Every few minutes, and when the
// tab gets focus again, compare the main bundle named in the live index.html with the one this tab loaded and
// show a banner with a reload button when they differ. Nothing happens in development (no hashed bundle).
const CHECK_EVERY_MS = 5 * 60 * 1000;

const mainBundleOf = (html) => {
  const match = /\/static\/js\/(main\.[0-9a-f]+\.js)/.exec(html || '');
  return match ? match[1] : null;
};

const NewVersionNotice = () => {
  const shown = useRef(false);

  useEffect(() => {
    const loaded = mainBundleOf(Array.from(document.scripts).map((s) => s.src).join(' '));
    if (!loaded) return undefined;

    const showBanner = () => {
      if (shown.current) return;
      shown.current = true;
      const bar = document.createElement('div');
      bar.setAttribute('role', 'alert');
      bar.style.cssText =
        'position:fixed;left:0;right:0;top:0;z-index:99999;background:#262564;color:#fff;padding:10px 16px;' +
        'display:flex;gap:12px;align-items:center;justify-content:center;font-size:14px;';
      bar.innerHTML =
        '<span>Ada versi CMS yang lebih baru. Muat ulang supaya memakai perbaikan terbaru dan tidak menyimpan data dengan versi lama.</span>' +
        '<button style="background:#fff;color:#262564;border-radius:6px;padding:4px 12px;font-weight:600;">Muat ulang</button>';
      bar.querySelector('button').addEventListener('click', () => window.location.reload());
      document.body.appendChild(bar);
    };

    const check = async () => {
      if (shown.current) return;
      try {
        const res = await fetch('/index.html?v=' + Date.now(), { cache: 'no-store' });
        const live = mainBundleOf(await res.text());
        if (live && live !== loaded) showBanner();
      } catch (e) {
        // offline or a blip: try again at the next check
      }
    };

    const timer = setInterval(check, CHECK_EVERY_MS);
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return null;
};

export default NewVersionNotice;
